module.exports = __webpack_public_path__ + "static/media/banner_l_03.0a5066a7.jpg";